import {useQuery} from 'react-query'
import {deleteShift, fetchShiftList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import ShiftForm from './Form'
import toast, {Toaster} from 'react-hot-toast'
import DeleteButton from '../../../components/DeleteButton'
import ModalWithForm from '../../../components/ModalWithForm'
import EditBtn from '../../../components/EditBtn'
import {Button} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import {formatTime} from '../../../helpers/dateFunctions'
import {Helmet} from 'react-helmet'
import PortalDropdown from '../../../components/PortalDropdown'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import EditLabel from '../../../components/EditLabel'
import DeleteLabel from '../../../components/DeleteLabel'
import TopBarProgress from 'react-topbar-progress-indicator'

const shiftBreadcrumbs = [
  {
    title: 'School Management',
    path: 'school-management/shift',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function Shift() {
  const {data, isError, isFetching, isLoading, refetch} = useQuery('classList', fetchShiftList, {
    refetchOnWindowFocus: false,
  })

  if (isLoading) {
    return <Processing />
  }
  const cellModifier = {
    starting_time: ({value}) => formatTime(value),
    ending_time: ({value}) => formatTime(value),

    Actions: ({row}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Shift'}
              initialValues={row.original}
              onSubmit={refetch}
              Form={ShiftForm}
              modalAttrs={{size: 'sm'}}
              triggerClassName="d-block"
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteShift(row.original.shift_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }

  return (
    <>
      <Helmet>
        <title>TrackNAB | Shifts</title>
      </Helmet>
      <PageTitle breadcrumbs={shiftBreadcrumbs}>Shift</PageTitle>
      {isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={data?.data || []}
          {...viewProps.Shift}
          fieldToLabelMap={viewProps.Shift.primaryFieldsToLabelMap}
          Form={ShiftForm}
          formSize={{size: 'md'}}
          cellModifier={cellModifier}
          nonSortableColumns={['Actions']}
          headerExtras={
            <ModalWithForm
              modalTitle={'Add Shift'}
              triggerClassName="ms-auto"
              onSubmit={refetch}
              Form={ShiftForm}
              modalAttrs={{size: 'sm'}}
            >
              <Button size="sm">Add Shift</Button>
            </ModalWithForm>
          }
        />
      )}
      {isFetching && <TopBarProgress />}

      <Toaster />
    </>
  )
}

export default Shift
